var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_895_526",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 9,
    width: 37,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.51 9H7V41.5982H43.51V9Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_895_526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9489 10.3036H10.9145C9.47422 10.3036 8.30664 11.4712 8.30664 12.9114V17.4752M8.30664 17.4752V37.0342C8.30664 38.4745 9.47422 39.642 10.9145 39.642H39.6009C41.0413 39.642 42.2087 38.4745 42.2087 37.0342V20.0831C42.2087 18.6428 41.0413 17.4752 39.6009 17.4752H8.30664Z",
    stroke: "#FF000C",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3373 24.9728H42.5309V32.1444H36.3373C34.3569 32.1444 32.7515 30.5389 32.7515 28.5586C32.7515 26.5781 34.3569 24.9728 36.3373 24.9728Z",
    stroke: "#FF000C",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.62b2a01ffca8797d217f9088b2019f74.svg";
export { ForwardRef as ReactComponent };